// I18n
import { i18next, initReactI18next, resources } from "@/lib/i18n"

// Env variables
import { DEBUG_I18N } from "@/lib/env"

// Logging
import { addBreadcrumb } from "@/lib/sentry"

// State
import { store } from "@/state/store"
// The Redux store returns the language enum in upper-case (e.g. "NL"), but
// resource bundles from `vite-plugin-i18next-loader` are keyed by the
// lower-case directory name (`nl`). Normalize once here.
const DETECTED_LANGUAGE = (
	store.getState().userPreferences.lang ?? "nl"
).toLowerCase()

/**
 * initI18n
 * @returns
 */
export const initI18n = () => {
	return (
		i18next
			// pass the i18n instance to react-i18next.
			.use(initReactI18next)
			.init({
				debug: DEBUG_I18N === "true",
				ns: [
					"common",
					"payments",
					"finance",
					"profile",
					"investor",
					"investments",
					"project",
					"projects",
					"dashboard",
					"dialog",
					"not-found",
					"recent",
					"locale",
					"d3-time-format",
				],
				fallbackLng: DETECTED_LANGUAGE,
				defaultNS: "common",

				resources,

				/**
				 * Namespace uses ':' as separator. Keys are flat strings that
				 * may contain '.' as part of the identifier (e.g. "brand.name"),
				 * so keySeparator is disabled — i18next will look up the whole
				 * key verbatim in the namespace bundle rather than treating
				 * dots as nested-object paths.
				 */
				nsSeparator: ":",
				keySeparator: false,

				lng: DETECTED_LANGUAGE,

				interpolation: {
					// react is already safe from xss
					escapeValue: false,
				},
				saveMissing: true,
				missingKeyHandler: (
					ngs,
					ns,
					key,
					fallbackValue,
					updateMissing,
					options,
				) => {
					// Add Sentry breadcrumb
					addBreadcrumb({
						category: "i18n",
						message: "Missing i18n key",
						data: {
							ngs,
							ns,
							key,
							fallbackValue,
							updateMissing,
							options,
						},
					})

					// Add Sentry breadcrumb
					console.warn("Missing i18n key", {
						ngs,
						namespace: ns,
						key,
						fallbackValue,
						updateMissing,
						options,
					})
				},
			})
	)
}

export { i18next }
